<template>
	<div class="logos_list">
		<div class="container">

			<div class="inner">
				<h3
					v-if="title"
					v-html="title"
				></h3>
				<p
					v-if="text"
					v-html="text"
				></p>

				<div class="logos">
					<a
						v-for="(builder, index) in JSON.parse(logos)"
						:key="index"
						:href="builder.link ? builder.link.url : ''"
						:target="builder.link ? builder.link.target : '_self'"
						class="builder"
					>
						<img
							:src="builder.logo ? builder.logo.url : ''"
							:alt="builder.name ? builder.name : 'CPMEC Builder'"
						/>
					</a>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		title: {},
		text: {},
		logos: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		console.log(JSON.parse(this.logos));
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.inner {
	padding-bottom: $spacer * 4;

	@include until(tablet) {
		padding-bottom: $spacer * 2;
	}

	h3 {
		font-family: $font-family;
		font-style: normal;
		font-weight: normal;
		font-size: 50px;
		line-height: 60px;
		letter-spacing: 0;
		color: $cpmec-blue;
		border-top: 1px solid $cpmec-blue;
		padding-top: $spacer * 4;
		text-align: center;

		@include until(tablet) {
			padding-top: $spacer * 2;
			margin-top: 0;
		}
	}

	p {
		margin: 0 0 $spacer * 4;
		font-size: 22px;
		color: $cpmec-grey;
		text-align: center;

		@include until(tablet) {
			margin: 0 0 $spacer * 2;
		}
	}

	.logos {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		gap: $spacer * 2;

		@media (max-width: $lg) {
			grid-template-columns: repeat(4, 1fr);
		}

		@include until(large-tablet) {
			grid-template-columns: repeat(3, 1fr);
			gap: $spacer * 1;
		}

		@include until(tablet) {
			grid-template-columns: repeat(2, 1fr);
		}

		a {
			display: flex;

			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/LogosList.vue